import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import tw from './i18n/tw';
import ch from './i18n/ch';

i18next.addResourceBundle('en', 'home', en);
i18next.addResourceBundle('tw', 'home', tw);
i18next.addResourceBundle('ch', 'home', ch);

const HomeConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/home',
			component: React.lazy(() => import('./Home'))
		}
	]
};

export default HomeConfig;
